<template>
    <section class="app-main">

        <div class="top-bar">
            
            <el-date-picker v-model="selectDate" @change="searchMonth"  type="month" align="left" value-format="yyyy-MM" placeholder="选择月" style="width:200px"></el-date-picker>

            <el-select v-model="value" @change="getData" placeholder="选择物流公司" clearable  style="width:200px;margin-left:20px;">
                <el-option v-for="item in options" :key="item.value"  :label="item"  :value="item"></el-option>
            </el-select>
            <el-input placeholder="查询订单号" v-model="title" @change="search" clearable style="width:220px;margin:0 20px 15px;">
                <i slot="prefix" class="el-input__icon el-icon-search"></i>   
            </el-input>   
            <div >
                <el-tag  type="danger">所有总计：C${{trans_currency.CAD.total_amount}} + US${{trans_currency.USD.total_amount}}</el-tag>   
                <el-tag  type="danger">当页总计：C${{trans_currency.CAD.current_total_amount}} + US${{trans_currency.USD.current_total_amount}}</el-tag>   
            </div>
            
        </div>
        <!-- 商品列表 -->
        <el-card >
            <el-table  :data="orderList"   height="600" >
                <el-table-column prop="title"  align="center" label="订单号"  > </el-table-column>
                <el-table-column prop="addr_details" align="center" label="配送地址" min-width="190"  show-overflow-tooltip> </el-table-column>
                <el-table-column prop="carrier_name" label="配送物流"  align="center" ></el-table-column>
                <el-table-column prop="delivery_time_title"    align="center"   label="发货时间"> </el-table-column>
                <el-table-column prop="freight" align="center"  label="配送金额" >
                    <template slot-scope="scope">
                        <span>{{scope.row.country == 507?'US$':'C$'}}{{scope.row.freight}}</span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination  background layout="prev, pager, next" style="padding:10px" :total="total" @current-change="reloadData" :page-size="20">  </el-pagination>
        </el-card>
    </section>
</template>




<script>

import { logistics } from "@/api/platform.js"

export default {
    data() {
        return {
            title: '',
            total:0,
            page:1,
            orderList: [],
            table_load:false,
            options: [],
            value:'',
            // 选择日期
            selectDate: '',
            totalPrice:`0.00`,
            totalPage: '0.00',
            trans_currency: {
                CAD: {
                    current_total_amount: '0.00',
                    total_amount: '0.00'
                },
                USD: {
                    current_total_amount: '0.00',
                    total_amount: '0.00'
                }
            }
        }
    },
    methods: {
        
        search() {
            this.page = 1
            this.selectDate = ''
            this.value = ''
            this.getData()
        },

        searchMonth() {
            this.page = 1
            this.title = ''
            this.value = ''
            this.getData()
        },


        getData(){
            let params = {
                page:this.page
            }
            if(this.selectDate != ""){
                params.month_search = this.selectDate
            }
            if(this.value != ""){
                params.carrier_search = this.value
            }
            if(this.title != ""){
                params.title_search = this.title
            }
            logistics(params).then(res => {
                if(res){
                    this.orderList  = res.data.list.data;
                    this.options    = res.data.carrier_name;
                    this.total      = res.data.list.total;
                    // this.totalPrice = res.data.total_amount
                    // this.totalPage  = res.data.current_total_amount
                    if(res.data.trans_currency) {
                        this.trans_currency.CAD = res.data.trans_currency.CAD
                        if(res.data.trans_currency.USD) {
                            this.trans_currency.USD = res.data.trans_currency.USD
                        }
                    }
                }else{
                    this.orderList = [];
                    this.totalPrice = '0.00'
                    this.totalPage  = '0.00'
                }
            })
        },
        reloadData(page){
            this.page = page;
            this.getData();
        },

    },
    created(){
        this.getData();
    },
    activated() {
        this.getData()
    },
}
</script>


<style lang="less" scoped>
section {
    /deep/ .el-tag + .el-tag{ 
        margin-left: 20px;
    }
}
</style>
